import { Nullable } from "../Extensions";
import { StringHelper } from "../Helpers/StringHelper";
import { RadObject } from "../RadObject";
import { NAMESPACE } from "./_Namespace";

export class ODataHelper extends RadObject
{
    public static override classNamespace = NAMESPACE + "ODataHelper";
    public static override className = "ODataHelper";

    public static objectPropertyPathToODataPropertyPath(objectPropertyPath?: Nullable<string>)
    {
        return objectPropertyPath ? objectPropertyPath.replace(/\./gi, "/") : StringHelper.empty;
    }
}